<template>
  <v-container>
    <v-row>
      <v-col
        cols="4"
        md="2"
      >
        <b>Employer Nationality</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ driver.employer_nationality }}
      </v-col><v-col
        cols="4"
        md="2"
      >
        <b>Driving Area</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ driver.driving_area }}
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Customer own a car</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ driver.has_car ? 'Yes' : 'No' }}
      </v-col>
      <v-col
        v-if="driver.has_car"
        cols="4"
        md="2"
      >
        <b>Type of Car Customer has</b>
      </v-col>
      <v-col
        v-if="driver.has_car"
        cols="8"
        md="4"
      >
        <p
          v-for="(item, i) in driver.car_type"
          :key="i"
        >
          {{ item }}
        </p>
      </v-col>
      <v-col
        v-if="driver.has_car"
        cols="4"
        md="2"
      >
        <b>Type of Car's Gear</b>
      </v-col>
      <v-col
        v-if="driver.has_car"
        cols="8"
        md="4"
      >
        <p
          v-for="(item, i) in driver.car_gear_type"
          :key="i"
        >
          {{ item }}
        </p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Expect Language from Driver:</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p
          v-for="(item, i) in driver.expect_language"
          :key="i"
        >
          {{ item }}
        </p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Prefer Driver's Age:</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p
          v-for="(item, i) in driver.prefer_age_range"
          :key="i"
        >
          {{ item }}
        </p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Work Day:</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p
          v-for="(item, i) in driver.work_day"
          :key="i"
        >
          {{ item }}
        </p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Work Time:</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ driver.work_time }}
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Currently Hired Driver:</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ driver.any_driver ? 'Yes' : 'No' }}
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Expected Salary for Candidate:</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p
          v-for="(item, i) in driver.expect_salary"
          :key="i"
        >
          {{ item }}
        </p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Offer Over-Time for Driver:</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p>
          {{ driver.is_ot ? "Yes" : "No" }}
        </p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Start Hiring:</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ driver.start_hiring }}
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Interview Preference:</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ driver.interview_channel }}
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Replacement Guarantee:</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ driver.replacement_guarantee }}
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'DriverDetail',
  props: ['driver']
}
</script>
